import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';

@Injectable()
export class StandardErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

private extractErrorMessage(error: any): string {
  if (!error || typeof error !== 'object') {
    return error?.toString() || 'An error occurred';
  }

  const lines: string[] = [];

  // Title first
  // if (error.title) {
  //   lines.push(error.title);
  // }

  if (error.errors && typeof error.errors === 'object') {
    Object.values(error.errors).forEach((fieldErrors: any) => {
      if (Array.isArray(fieldErrors)) {
        fieldErrors.forEach(e => lines.push(`${e}`));
      }
    });
  }

  // Fallback to detail if no errors
  else if (error.detail) {
    lines.push(`${error.detail}`);
  }

  return lines.length ? lines.join('\n') : 'An error occurred';
}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.error instanceof Blob && error.status !== 200 && error.status != 202 && error.status != 204) {
          return new Observable<HttpEvent<unknown>>((observer) => {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent) => {
              // Correct type here
              try {
                const target = e.target as FileReader; // Type assertion for target
                if (target && target.result !== null) {

                  let errorMessage = '';
                  try {
                    const parsedError = JSON.parse(target.result as string);
                    errorMessage = this.extractErrorMessage(parsedError);
                  } catch {
                    errorMessage = (target.result as string).replace(/"/g, '');
                  }

                  switch (error.status) {
                    case 401:
                      this.authService.logout();
                      observer.error(
                        "Your session has expired. Please log in again.",
                      );
                      observer.complete();
                      return;
                    case 403:
                      observer.error(
                        "You don't have permission to perform this action.",
                      );
                      observer.complete();
                      return;
                    case 404:
                    case 400:
                    case 500:
                    case 504:
                      observer.error(errorMessage);
                      observer.complete();
                      return;
                    default:
                      observer.error(errorMessage || 'An error occurred.');
                      observer.complete();
                      return;
                  }
                } else {
                  observer.error('Error reading file.');
                  observer.complete();
                  return;
                }
              } catch (jsonError) {
                observer.error(this.extractErrorMessage(error.error));
                observer.complete();
                return;
              }
            };

            reader.onerror = (err) => {
              observer.error('Error reading file:' + err);
              observer.complete();
            };

            reader.readAsText(error.error);
          });
        }
        if (error.status === 0) {
          return throwError(() => 'Server is down. Try again later.');
        }
        // Handle Problem Details format for non-blob errors
        const errorMessage = this.extractErrorMessage(error.error);
        return throwError(() => errorMessage);
      }),
    );
  }
}
